import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { ADMIN } from "@/constants/testIds";
import { Star, Check, X } from "lucide-react";

export default function AdminReviews() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const { data } = await api.get("/admin/reviews"); setItems(data);
  };
  useEffect(() => { load(); }, []);

  const patch = async (id, body) => {
    await api.patch(`/admin/reviews/${id}`, body);
    await load();
  };

  return (
    <div className="p-8 md:p-12">
      <div className="overline">Admin</div>
      <h1 className="font-serif-display text-4xl mt-2">Reviews</h1>
      <div className="mt-10 grid md:grid-cols-2 gap-4">
        {items.map(r => (
          <div key={r.id} className="border border-[#E2E8F0] bg-white p-6">
            <div className="flex items-center gap-1 text-[#0F172A]">
              {Array.from({ length: r.rating }).map((_, i) => <Star key={i} size={16} className="fill-current"/>)}
            </div>
            <p className="mt-3 text-sm text-[#0F172A]">"{r.text}"</p>
            <div className="mt-3 text-xs text-[#4A4A4A]">— {r.customer_name}{r.booking_code && ` · ${r.booking_code}`}</div>
            <div className="mt-4 flex flex-wrap gap-3">
              <button data-testid={ADMIN.reviewApproveBtn(r.id)} onClick={() => patch(r.id, { approved: !r.approved })}
                      className={`text-xs uppercase tracking-widest px-3 py-2 border ${r.approved ? "bg-[#0F172A] text-white border-[#0F172A]" : "border-[#0F172A]"}`}>
                <Check size={12} className="inline mr-1"/> {r.approved ? "Approved" : "Approve"}
              </button>
              <button data-testid={ADMIN.reviewFeatureBtn(r.id)} onClick={() => patch(r.id, { featured: !r.featured })}
                      className={`text-xs uppercase tracking-widest px-3 py-2 border ${r.featured ? "bg-[#D4AF37] border-[#D4AF37]" : "border-[#0F172A]"}`}>
                <Star size={12} className="inline mr-1"/> {r.featured ? "Featured" : "Feature"}
              </button>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="text-[#4A4A4A] text-sm">No reviews yet.</div>}
      </div>
    </div>
  );
}
